export enum AuthStatus {
    checking = "checking",
    authenticated = "authenticated",
    notAuthenticated = "notAuthenticated",
}
